import * as _ from 'lodash';

import { AlarmList, Alarm } from '../../models/index';
import { StoreItem } from '../';
import ReducerCreator from '../registerReducer';
import * as AT from './alarmTemplate.constants';
import { APPLICATION_DISCONNECTED } from '../constants.index';


const r = new ReducerCreator<Alarm[]>()
    .register<string>(APPLICATION_DISCONNECTED, (state, payload) => {
        return new StoreItem<Alarm[]>();
    })
    .register<any>(AT.ALARM_TEMPLATE_LOAD, (state, payload) => {
        return {
            dictionary: {},
            isLoading: true,
            isLoaded: false,
            hasError: false,
            error: null
        };
    })
    .register<AlarmList>(AT.ALARM_TEMPLATE_LOAD_SUCCESS, (state, payload) => {
        return buildAlarmTemplatesStoreItem(payload);
    })
    ;

export function alarmTemplatesReducer(
    state: StoreItem<Alarm[]> = new StoreItem<Alarm[]>(),
    action: { type: string, payload: any }
) {
    return r.reduce(state, action);
}

function buildAlarmTemplatesStoreItem(payload: AlarmList): StoreItem<Alarm[]> {
    const dic = {};
    const keys = Object.keys(payload);
    keys.forEach(k => dic[k] = payload[k]);
    return {
        dictionary: dic,
        isLoading: false,
        isLoaded: true,
        hasError: false,
        error: null
    };
}